import { IsBoolean } from "class-validator";

export class AdminDisableUserResult {
    @IsBoolean()
    success: boolean;
}